<template>
  <div>
    <p v-if="!updates || (updates.length <= 0 && !loading)" class="text-center">
      <b>
        You have not created any posts, Please
        <span :style="{ cursor: 'pointer', 'text-decoration': 'underline' }" @click="pushToHome"> Click here</span>
        to create a new post
      </b>
    </p>

    <div v-if="loading" class="d-flex justify-content-center">
      <div class="spinner-border position-absolute spinner-class"></div>
    </div>
    <div v-if="updates && !loading">
      <p :style="{ 'font-weight': '700', 'font-size': '32px', 'line-height': '42px', color: '#0F1734' }">Recent Activity</p>

      <div v-for="(update, index) in updates" :key="index">
        <Post v-if="update.content_type === 'post'" :postData="update"></Post>
        <Question v-if="update.content_type === 'question'" :quesData="update.user_question"></Question>
        <div v-if="update.content_type === 'poll' && update.user_poll">
          <PollCard :pollData="update.user_poll" />
        </div>
      </div>
      <span v-if="updates && pagination">
        <span v-if="updates.length != pagination.total_count" :style="{ color: getPrimaryColor(), textAlign: 'center', display: 'block', cursor: 'pointer' }" @click="fetch(true)">View More</span>
      </span>
    </div>
  </div>
</template>

<script>
import PollCard from "../../home/poll/UserPollCard.vue"
import Post from "../../home/Post"
import Question from "../Patient/QA/Question"
import { RepositoryFactory } from "../../../repositories/RepositoryFactory"

const UserRepository = RepositoryFactory.get("user")

export default {
  name: "PatientUpdates",
  components: {
    Post,
    Question,
    PollCard,
  },
  data() {
    return {
      updates: [],
      pagination: [],
      currentPage: 1,
      limit: 10,
      showNo: false,
      loading: false,
    }
  },

  created() {
    this.fetch()
  },

  methods: {
    pushToHome() {
      this.$router.push({ name: "ActivityHome" })
    },
    fetch(append = false) {
      this.loading = true
      UserRepository.getUpdates(this.currentPage, this.limit, this.authUser.user, this.currentCircle.id)
        .then(res => {
          this.loading = false
          if (append) {
            this.updates.push(...res.data.data.data)
          } else {
            if (res.data) {
              this.updates = res.data.data.data
              this.pagination = res.data.data.paginator ? res.data.data.paginator : []
            }
          }
          this.currentPage += 1
          console.log(this.updates, "advocate updates")
          this.updates.length === 0 ? this.showNo === false : this.showNo === true
        })
        .catch(err => {})
    },
  },
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Users/Advocate/AdvocateUpdates.vue